export const cilDoubleLeft = [
  '24 24',
  `
<g>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_1340_4457)">
  <path d="M9.1195 12L12.3169 8.14659C12.3663 8.0875 12.3217 8 12.241 8H11.3097C11.2507 8 11.1941 8.02614 11.1579 8.06932L8.08222 11.7761C8.02895 11.8402 8 11.9192 8 12.0006C8 12.082 8.02895 12.161 8.08222 12.225L11.1579 15.9307C11.1941 15.975 11.2507 16 11.3097 16H12.241C12.3217 16 12.3663 15.9125 12.3169 15.8534L9.1195 12ZM12.7819 12L15.9793 8.14659C16.0287 8.0875 15.9841 8 15.9034 8H14.9722C14.9131 8 14.8565 8.02614 14.8204 8.06932L11.7446 11.7761C11.6914 11.8402 11.6624 11.9192 11.6624 12.0006C11.6624 12.082 11.6914 12.161 11.7446 12.225L14.8204 15.9307C14.8565 15.975 14.9131 16 14.9722 16H15.9034C15.9841 16 16.0287 15.9125 15.9793 15.8534L12.7819 12Z" fill="#9AA1AE"/>
  <path d="M-1 4C-1 1.23858 1.23858 -1 4 -1H24V1H4C2.34315 1 1 2.34315 1 4H-1ZM24 25H4C1.23858 25 -1 22.7614 -1 20H1C1 21.6569 2.34315 23 4 23H24V25ZM4 25C1.23858 25 -1 22.7614 -1 20V4C-1 1.23858 1.23858 -1 4 -1V1C2.34315 1 1 2.34315 1 4V20C1 21.6569 2.34315 23 4 23V25ZM24 0V24V0Z" fill="#9AA1AE" mask="url(#path-2-inside-1_1340_4457)"/>
  </g>
  <defs>
  <clipPath id="clip0_1340_4457">
  <path d="M0 0H24V24H0V0Z" fill="white"/>
  </clipPath>
  </defs>
  </svg>

</g>
`,
]

export const cilDoubleRight = [
  '24 24',
  `
<g>

<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1340_4798)">
<path d="M15.8805 12L12.6831 15.8534C12.6337 15.9125 12.6783 16 12.759 16L13.6903 16C13.7493 16 13.8059 15.9739 13.8421 15.9307L16.9178 12.2239C16.971 12.1598 17 12.0808 17 11.9994C17 11.918 16.971 11.839 16.9178 11.775L13.8421 8.06932C13.8059 8.025 13.7493 8 13.6903 8L12.759 8C12.6783 8 12.6337 8.0875 12.6831 8.14659L15.8805 12ZM12.2181 12L9.02068 15.8534C8.97128 15.9125 9.01586 16 9.09657 16L10.0278 16C10.0869 16 10.1435 15.9739 10.1796 15.9307L13.2554 12.2239C13.3086 12.1598 13.3376 12.0808 13.3376 11.9994C13.3376 11.918 13.3086 11.839 13.2554 11.775L10.1796 8.06932C10.1435 8.025 10.0869 8 10.0278 8L9.09658 8C9.01586 8 8.97128 8.0875 9.02068 8.14659L12.2181 12Z" fill="#CDD0D6"/>
<rect x="0.5" y="0.5" width="23" height="23" rx="3.5" stroke="#CDD0D6"/>
</g>
<defs>
<clipPath id="clip0_1340_4798">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
</g>
`,
]

export const cilSave = [
  '16 17',
  `
<g>
<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1392_7273)">
<path d="M4.79987 15.9665V12.7665C4.79987 12.4836 4.91225 12.2123 5.11229 12.0123C5.31233 11.8123 5.58364 11.6999 5.86654 11.6999H10.1332C10.4161 11.6999 10.6874 11.8123 10.8875 12.0123C11.0875 12.2123 11.1999 12.4836 11.1999 12.7665V15.9665M14.3999 15.9665H1.59987C1.31697 15.9665 1.04566 15.8542 0.845623 15.6541C0.645584 15.4541 0.533203 15.1828 0.533203 14.8999V2.09987C0.533203 1.81697 0.645584 1.54566 0.845623 1.34562C1.04566 1.14558 1.31697 1.0332 1.59987 1.0332H10.7583C11.0411 1.03326 11.3124 1.14568 11.5124 1.34574L15.154 4.98734C15.3541 5.18733 15.4665 5.4586 15.4665 5.74147V14.8999C15.4665 15.1828 15.3542 15.4541 15.1541 15.6541C14.9541 15.8542 14.6828 15.9665 14.3999 15.9665Z" stroke="white" stroke-width="1.06667"/>
</g>
<defs>
<clipPath id="clip0_1392_7273">
<rect width="16" height="16" fill="white" transform="translate(0 0.5)"/>
</clipPath>
</defs>
</svg>
</g>
`,
]



